import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  requestNoPagination,
  requestSingle,
  requestAddTag,
  requestGetTypes
} from "actions/tag/requests";

import {
  TAG_LOADING,
  TAG_ERROR,

  TAG_GET_LIST,
  TAG_GET_LIST_NO_PAGINATION,
  TAG_GET_FILTERS,
  TAG_GET_SINGLE,
  TAG_CREATE_TAG,
  TAG_GET_TYPES
} from "actions/tag/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: TAG_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("tag")
    .then(response => {
      dispatch({
        type: TAG_GET_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TAG_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "startDate,desc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("tag", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: TAG_GET_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TAG_ERROR));
    });
};

export const getNoPagination = (filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestNoPagination(filters)
    .then((response) => {
      dispatch({
        type: TAG_GET_LIST_NO_PAGINATION,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TAG_ERROR));
    });
};

export const getSingle = (tagId) => dispatch => {
  if (tagId === false) {
    dispatch({
      type: TAG_GET_SINGLE,
      payload: {}
    });
    return;
  }
  dispatch(setLoading(true));
  requestSingle(tagId)
    .then(response => {
      dispatch({
        type: TAG_GET_SINGLE,
        payload: response.data && response.data.content && response.data.content.content && response.data.content.content[0]
          ? response.data.content.content[0]
          : {}
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TAG_ERROR));
    });
};

export const addTag = (data, callback) => dispatch => {
  requestAddTag(data)
    .then(response => {
      dispatch({
        type: TAG_CREATE_TAG,
        payload: response.data
      });
      toast(`Tag ${data.id ? "updated" : "created"} successfully`, {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, TAG_ERROR));
    });
};

export const getTypes = () => dispatch => {
  dispatch(setLoading(true));
  requestGetTypes()
    .then((response) => {
      dispatch({
        type: TAG_GET_TYPES,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TAG_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/tag/actions.js